'use strict';

var stringify = require('./stringify.js');
var parse = require('./parse.js');

function JSONBigInt (options) {
  return {
    parse: parse(options),
    stringify: stringify
  };
}
;

module.exports = JSONBigInt;
